import { requestChatLambda } from './openaiApi'

export const fetchJsonResponse = async ({ messages, aiVersion, tools, signal }) => {
  return requestChatLambda({
    messages,
    aiVersion,
    tools,
    streamText: false,
    returnReader: false,
    signal
  })
}

export const streamJsonResponses = async ({ messages, aiVersion, onChunkReceived, signal }) => {
  if (typeof onChunkReceived !== 'function') {
    throw new Error('streamJsonResponses: onChunkReceived callback is required.')
  }

  const allReceivedObjects = []
  const reader = await requestChatLambda({
    messages,
    aiVersion,
    streamText: false,
    returnReader: true,
    signal
  })

  if (!reader) {
    return []
  }

  const decoder = new TextDecoder()
  let buffer = ''
  const delimiter = 'jsonobjectdelimiter'

  try {
    while (true) {
      if (signal?.aborted) {
        await reader.cancel()
        break
      }

      const { value, done } = await reader.read()

      if (done) {
        const trimmedBuffer = buffer.trim()

        if (trimmedBuffer) {
          try {
            const finalObj = JSON.parse(trimmedBuffer)
            await onChunkReceived(finalObj)
            allReceivedObjects.push(finalObj)
          } catch (e) {
            console.error('Error parsing final buffered JSON chunk:', e, 'Buffer:', trimmedBuffer)
          }
        }
        break
      }

      buffer += decoder.decode(value, { stream: true })

      let delimiterIndex
      while ((delimiterIndex = buffer.indexOf(delimiter)) !== -1) {
        const jsonString = buffer.substring(0, delimiterIndex)
        buffer = buffer.substring(delimiterIndex + delimiter.length)

        const trimmedJsonString = jsonString.trim()

        if (trimmedJsonString) {
          try {
            const obj = JSON.parse(trimmedJsonString)
            await onChunkReceived(obj)
            allReceivedObjects.push(obj)
          } catch (e) {
            console.error('Error parsing streamed JSON object:', e, 'Failed JSON string:', trimmedJsonString)
          }
        }
      }
    }
  } catch (error) {
    if (!reader.closed && signal && !signal.aborted) {
      await reader.cancel()
    }
    throw error
  }

  return allReceivedObjects
}

export const streamTextResponse = async ({ messages, aiVersion, onChunkReceived, signal }) => {
  if (typeof onChunkReceived !== 'function') {
    throw new Error('streamTextResponse: onChunkReceived callback is required.')
  }

  const reader = await requestChatLambda({
    messages,
    aiVersion,
    streamText: true,
    returnReader: true,
    signal
  })

  if (!reader) {
    return
  }

  const decoder = new TextDecoder()

  try {
    while (true) {
      if (signal?.aborted) {
        await reader.cancel()
        break
      }

      const { value, done } = await reader.read()

      if (done) {
        break
      }

      const textChunk = decoder.decode(value, { stream: true })
      await onChunkReceived(textChunk)
    }
  } catch (error) {
    if (!reader.closed && signal && !signal.aborted) {
      await reader.cancel()
    }
    throw error
  }
}
